import { NgModule } from '@angular/core';
import { UserCreatePage } from './create/create.page';
import { UserIndexPage } from './index/index.page';
import { DatatablesModule } from '../../datatables/datatables.module';
import { FormsModule } from '../../forms/forms.module';
import { UserEditPage } from './edit/edit.page';
import { RouteService } from '../../routing/services/route.service';
import { RoutingModule } from '../../support/modules/routing-module';
import { RoutingModuleContract } from '../../support/modules/interfaces/routing-module.interface';

@NgModule({
    imports: [
        DatatablesModule,
        FormsModule
    ],
    exports: [],
    declarations: [
        UserIndexPage,
        UserCreatePage,
        UserEditPage
    ],
    entryComponents: [
        UserIndexPage,
        UserCreatePage,
        UserEditPage
    ],
    providers: []
})
export class UsersRoutingModule extends RoutingModule implements RoutingModuleContract {

    public routes(routes: RouteService) {
        routes.add('users', UserIndexPage, 'users.index', {layout: 'full-width', permission: 'user.read'});
        routes.add('users/create', UserCreatePage, 'users.create', {permission: 'user.write'});
        routes.add('users/:user', UserEditPage, 'users.show', {permission: 'user.read'});
        routes.add('users/:user/edit', UserEditPage, 'users.edit', {permission: 'user.read' });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/users/users-routing.module.ts